import React from 'react';

import PagesIcon from '@material-ui/icons/Pages';

import {
  PERMISSAO_TELA_COMPRAS_LISTAR,
  PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR,
  PERMISSAO_TELA_BONIFICACOES_LISTAR,
  PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR,
  PERMISSAO_TELA_NFES_CIENTES_LISTAR,
  PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR,
  PERMISSAO_TELA_OUTROS_CONTATOS,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuCompras = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Fornecimento"
    icon={<PagesIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_COMPRAS_LISTAR] && hasResource('compras')}
    {permissoes[PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR] &&
      hasResource('compras_de_insumos')}
    {permissoes[PERMISSAO_TELA_BONIFICACOES_LISTAR] &&
      hasResource('compras_de_bonificacoes')}
    {permissoes[PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR] &&
      hasResource('compras_de_servicos')}
    {permissoes[PERMISSAO_TELA_NFES_CIENTES_LISTAR] &&
      hasResource('nfe_compras')}
    {permissoes[PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR] &&
      hasResource('nfe_compras_problematicas')}
    {permissoes[PERMISSAO_TELA_FORNECEDORES_LISTAR] &&
      hasResource('fornecedores')}
    {permissoes[PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR] &&
      hasResource('fornecedores_insumos')}
    {permissoes[PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR] &&
      hasResource('fornecedores_servicos')}
    {permissoes[PERMISSAO_TELA_OUTROS_CONTATOS] &&
      hasResource('fornecedores_qualquer')}
  </SubMenu>
);

export default SubMenuCompras;
